import {names as siteNames} from './modules/site.js'
import {flatGetters} from "../common/utils/helper";
const _getters = {
    ...flatGetters('site',siteNames)
}
const getters = Object.assign({}, _getters)
export default getters
